<!--
 * @Descripttion: 
 * @Author: Gavin
 * @version: 
 * @Date: 2020-07-27 09:15:58
 * @LastEditTime: 2020-07-28 20:44:47
--> 
<template>
	<div class="store-empty-conteiner">
		<div class="img-box" :class="[type]"></div>
		<p class="title">{{title}}</p>
	</div>
</template>

<script>
	export default {
		props: {
			type: {
				type: String,
				default: 'one'
			},
			title: {
				type: String,
				default: '啊哦~当前暂无产品哟~'
			}
		}
	}
</script>
<style lang="scss" scoped>
	.store-empty-conteiner{
		padding: 40px 0 30px;
		box-sizing: border-box;
		text-align: center;

		.img-box{
			background-size: 100% 100%;
			background-repeat: no-repeat;
			background-position: center;
			margin: 0 auto;

			&.one{
				width: 162px;
				height: 188px;
				background-image: url('../../../assets/imgs/store/empty.png');
			}
			&.two{
				width: 282px;
				height: 340px;
				background-image: url('../../../assets/imgs/store/img_empty.svg');
			}
		}
		.title{
			font-size: 24px;
			color: #C8C8C8;
			margin-top: 30px;
		}
	}
</style>